module.exports = __webpack_public_path__ + "static/media/ppg-dashboard-image.952b7343.jpg";